export const isBrowser = () => typeof window !== 'undefined'
export const countryCode = (locale: string) => locale.split('-')[1].toUpperCase()
